import { createSelector } from 'reselect';
import {
    selectFeatureFlags,
    selectPreferences,
    selectReqHeaders,
} from 'yoda-site-components/lib/selectors/ContextSelector';
import { isFeatureEnabled } from 'yoda-core-components/lib/helpers/Utils/Utils';
import { listsRedesignCookieFlagName, listsRedesignHeaderFlagName } from '../common/Constants';

const isListingRedesignEnabled = (featureFlags, preferences, reqHeaders) =>
    isFeatureEnabled(
        featureFlags,
        preferences,
        reqHeaders,
        'enableOOSListsRedesign',
        listsRedesignCookieFlagName,
        listsRedesignHeaderFlagName
    );

const selectListingRedesign = createSelector(
    [selectFeatureFlags, selectPreferences, selectReqHeaders],
    isListingRedesignEnabled
);

export default selectListingRedesign;
